import { useAuth } from '@frontegg/react';
import { PropsWithChildren } from 'react';
import { SplashScreen } from '../components/Common/Loaders/SplashScreen/SplashScreen';
import { useGetAccountByIdQuery } from '../store/rtk-query/apis/account/account.toolkit-api';
import { useGetMyUserQuery } from '../store/rtk-query/apis/user/user.toolkit-api';
import { PricingPlan } from '../enums/user-plan.enum';
import { AccountStatusEnum } from '../enums/account-status.enum';
import { PlanExpired } from '../modules/trial-ended/pages/plan-expired.page';

export const PlanExpirationGuard = ({
  children,
}: PropsWithChildren<unknown>): JSX.Element => {
  const { isAuthenticated, isLoading: isLoadingAuth } = useAuth();

  const {
    data: { accountId } = {},
    isLoading: isLoadingUser,
  } = useGetMyUserQuery(undefined, { skip: !isAuthenticated });
  const {
    data: { plan, status: accountStatus } = {},
    isLoading: isLoadingAccount,
  } = useGetAccountByIdQuery(accountId, { skip: !accountId });

  if (
    (plan?.isExpired || plan?.pricingPlan === PricingPlan.Lite) &&
    accountStatus !== AccountStatusEnum.Onboarding
  ) {
    return <PlanExpired />;
  }

  if (isLoadingAuth || isLoadingUser || isLoadingAccount) {
    return <SplashScreen title="Plan Expiration Guard" />;
  }

  return <>{children}</>;
};
